import { asDarkSvg, asDisabledSvg, asLightSvg } from '../../hocs';
import SidebarOverlayPositionSvg from './SidebarOverlayPositionSvg';

const LightSidebarOverlayPositionSvg = asLightSvg(SidebarOverlayPositionSvg);
const DarkSidebarOverlayPositionSvg = asDarkSvg(SidebarOverlayPositionSvg);
const DisabledSidebarOverlayPositionSvg = asDisabledSvg(SidebarOverlayPositionSvg);

export default SidebarOverlayPositionSvg;
export {
    SidebarOverlayPositionSvg,
    LightSidebarOverlayPositionSvg,
    DarkSidebarOverlayPositionSvg,
    DisabledSidebarOverlayPositionSvg,
};
